import { useMutation } from '@tanstack/react-query';

import { deleteProfileImage } from '../api/user';

export interface UseMutateDeleteProfileImageOptions {
  onSuccess?: () => void;
  onError?: () => void;
  onSettled?: () => void | Promise<void>;
}

export function useMutateDeleteProfileImage(
  options?: UseMutateDeleteProfileImageOptions
) {
  return useMutation({
    mutationFn: () => deleteProfileImage(),
    onSuccess: () => {
      options?.onSuccess?.();
    },
    onError: () => {
      options?.onError?.();
    },
    onSettled: () => options?.onSettled?.(),
  });
}
